import React, {useState} from 'react';
import './ProductFilter.scss';

const ProductFilter = ({onToggleViewMode, filters, setFilters}) => {
    const [activeView, setActiveView] = useState('list');

    const handleButtonClick = (viewMode) => {
        if (viewMode === activeView) {
            return;
        }
        onToggleViewMode();
        setActiveView(viewMode);
    };

    const handleSortChange = (e) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            sort: e.target.value,
        }));
    };

    const handleShowChange = (e) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            show: e.target.value,
        }));
    };

    const handleTypeChange = (event) => {
        const {value, checked} = event.target;
        setFilters((prevFilters) => {
            const updatedFilters = {...prevFilters};
            if (value === 'standard') {
                updatedFilters.types = checked
                    ? ['standard']
                    : updatedFilters.types.filter((type) => type !== 'standard');
            } else if (value === 'subscription') {
                updatedFilters.types = checked
                    ? ['subscription']
                    : updatedFilters.types.filter((type) => type !== 'subscription');
            } else {
                if (checked) {
                    updatedFilters.types = [...updatedFilters.types, value];
                } else {
                    updatedFilters.types = updatedFilters.types.filter((type) => type !== value);
                }
            }
            return updatedFilters;
        });
    };

    return (
        <div className="product-filter">
            <div className="sort-filter">
                <div className="form-item">
                    <label>Sort By:</label>
                    <select onChange={handleSortChange} value={filters.sort}>
                        <option value="p.sort_order">Default</option>
                        <option value="nameAsc">Name (A - Z)</option>
                        <option value="nameDesc">Name (Z - A)</option>
                        <option value="priceAsc">Price (Low &gt; High)</option>
                        <option value="priceDesc">Price (High &gt; Low)</option>
                        <option value="modelAsc">Model (A - Z)</option>
                        <option value="modelDesc">Model (Z - A)</option>
                    </select>
                </div>
                <div className="form-item">
                    <label>Show:</label>
                    <select onChange={handleShowChange} value={filters.show}>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="75">75</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </div>
            <div className="type-filter">
                <div className="form-item">
                    <input
                        className="ui-checkbox"
                        type="checkbox"
                        id="standard"
                        value="standard"
                        checked={filters.types.includes('standard')}
                        onChange={handleTypeChange}
                    />
                    <label className="ui-label standard" htmlFor="standard">
                        Standard
                    </label>
                </div>
                <div className="form-item">
                    <input
                        className="ui-checkbox"
                        type="checkbox"
                        id="subscription"
                        value="subscription"
                        checked={filters.types.includes('subscription')}
                        onChange={handleTypeChange}
                    />
                    <label className="ui-label subscription" htmlFor="subscription">
                        Subscription
                    </label>
                </div>
                <div className="form-item">
                    <input
                        className="ui-checkbox"
                        type="checkbox"
                        id="streaming"
                        value="streaming"
                        checked={filters.types.includes('streaming')}
                        onChange={handleTypeChange}
                    />
                    <label className="ui-label streaming" htmlFor="streaming">
                        Streaming
                    </label>
                </div>
                <div className="form-item">
                    <input
                        className="ui-checkbox"
                        type="checkbox"
                        id="free"
                        value="free"
                        checked={filters.types.includes('free')}
                        onChange={handleTypeChange}
                    />
                    <label className="ui-label free" htmlFor="free">
                        Free
                    </label>
                </div>
            </div>
            <div className="btn-filter">
                <button
                    className={`btn btn-list ${activeView === 'list' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('list')}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3-32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3-32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"/>
                    </svg>
                </button>
                <button
                    className={`btn btn-th ${activeView === 'th' ? 'active' : ''}`}
                    onClick={() => handleButtonClick('th')}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path
                            d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 64v64H64V96h88zm56 0h88v64H208V96zm240 0v64H360V96h88zM64 224h88v64H64V224zm232 0v64H208V224h88zm64 0h88v64H360V224zM152 352v64H64V352h88zm56 0h88v64H208V352zm240 0v64H360V352h88z"/>
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default ProductFilter;
